import Form from '@/app/components/UI/Form'
import Head from 'next/head'

export default function ContactFinancingPage() {
  return (
    <>
      <Head>
        <title>Azul Agro - Contato de Financiamento</title>
        <meta name="description" content="Entre em contato com a Azul Agro para tirar suas dúvidas sobre financiamento, solicitar informações detalhadas ou receber suporte técnico. Estamos prontos para ajudar você a otimizar suas operações agrícolas com nossas opções de financiamento flexíveis e acessíveis." />
      </Head>
      <main>
        <Form financing />
      </main>
    </>
  )
}
